import { useEffect } from 'react';
import { TariffResponse } from 'src/apis/capacity-management/types';
import { CmNetworkPointRequest } from 'src/apis/capacity-management/use-cm-network-point';
import { useAxios } from 'src/hooks/use-axios';

type HookConfig = {
  cmNetworkPoint: CmNetworkPointRequest;
};

type RequestOptions = {
  url: string;
};

export function useTariff({ cmNetworkPoint }: HookConfig) {
  const tariff = useAxios(
    (axios, signal, { url }: RequestOptions) =>
      axios.request<TariffResponse>({
        signal,
        url,
      }),
    { neededOnPageLoad: true }
  );

  useEffect(() => {
    if (!cmNetworkPoint.response) return;

    const url = cmNetworkPoint.response.data._links.tariff.href;
    const options = { url };

    tariff.execute(options);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cmNetworkPoint.response]);

  return tariff;
}

export type TariffRequest = ReturnType<typeof useTariff>;
